export const MAX_BODY_MESSAGE_SIZE = 500
